// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"fe54839a","title":"d55e3625","link":"cf4913f3","active":"b82803aa"};